import React from "react";
import { Award, Flame, ShieldCheck } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurQualityPromise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const features = [{
    title: "בשר משובח ואיכותי",
    description: "אנו בוחרים בקפידה את נתחי הבקר המובחרים ביותר, תוך דגש על טריות, יישון מדויק ומרקם מושלם לכל מנה.",
    icon: <Award className="w-10 h-10 text-primary" />
  }, {
    title: "עישון בעץ טבעי",
    description: "תהליך העישון שלנו מתבצע באמצעות גזרי עץ טבעיים שנבחרו בקפידה, המעניקים לבשר ארומה עמוקה וטעם מעושן אותנטי.",
    icon: <Flame className="w-10 h-10 text-primary" />
  }, {
    title: "ניקיון ללא פשרות",
    description: "המטבח שלנו פועל תחת סטנדרטים מחמירים של היגיינה וניקיון, כדי להבטיח לכם חוויה קולינרית בטוחה, נקייה ונעימה.",
    icon: <ShieldCheck className="w-10 h-10 text-primary" />
  }];
  return <section id="הבטחת-האיכות-שלנו" ref={ref} className={`dark bg-background text-foreground py-24 px-6 overflow-hidden transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-6 text-primary">
            הבטחת האיכות שלנו
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            ב-SMOKE & GO אנחנו לא מתפשרים על פחות מהטוב ביותר. מהבחירה בנתח ועד לצלחת שלכם, כל שלב מבוצע בתשוקה ובמקצועיות.
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-center items-stretch gap-8 lg:gap-12">
          {features.map((feature, i) => <div key={i} data-index={i} className="flex-1 min-w-0">
              <Card className="h-full bg-card/40 border-border/50 hover:bg-card/60 transition-colors duration-300 backdrop-blur-sm group">
                <CardHeader className="flex flex-col items-center text-center pt-10 pb-2">
                  <div className="mb-6 p-5 rounded-full bg-secondary/50 border border-primary/20 shadow-[0_0_15px_rgba(220,38,38,0.15)] group-hover:shadow-[0_0_25px_rgba(220,38,38,0.25)] transition-shadow duration-300">
                    {feature.icon}
                  </div>
                  <CardTitle className="text-2xl font-bold text-foreground mb-2">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-center pb-10 px-8">
                  <CardDescription className="text-base text-muted-foreground leading-relaxed">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}